module.exports = __webpack_public_path__ + "static/media/work-dissertation.257f0326.png";